import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    HeaderFilter,
    SearchPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const LocationInventoryResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "d1a8c6f4-59b2-4e73-a0d6-3b9f2c7e148a";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    return (
        <div style={{ height: '100%' }}>
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RowId"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                remoteOperations={true}
                columnAutoWidth={true}
            >
                <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
                    <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <HeaderFilter visible={false} />
                <SearchPanel visible={true} width={240} placeholder="Search..." />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />
                {/* Default-visible columns */}
                <Column dataField="ItemCode" caption="Item" sortOrder="asc" />
                <Column dataField="ItemDescription1" caption="Item Description 1" />
                <Column dataField="CustomerID" caption="Customer" />
                <Column dataField="CustomerName" caption="Customer Name" />
                <Column dataField="ClassCode" caption="Class" />
                <Column dataField="SubClassCode" caption="Sub Class" />
                <Column dataField="LotCode" caption="Lot" />
                <Column dataField="SubLotCode" caption="Sublot" />
                <Column dataField="UnitCode" caption="Unit" />
                <Column dataField="OnHand" caption="On Hand" />
                <Column dataField="Available" caption="Available" />
                <Column dataField="NetAvailable" caption="Net Available" />
                {/* Column chooser (hidden by default) */}
                <Column dataField="LocationCode" caption="Location" visible={false} />
                <Column dataField="Description" caption="Location Description" visible={false} />
                <Column dataField="ItemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="InOrdered" caption="In Ordered" visible={false} />
                <Column dataField="OutOrdered" caption="Out Ordered" visible={false} />
                <Column dataField="InReceiving" caption="In Receiving" visible={false} />
                <Column dataField="OutShipped" caption="Out Shipped" visible={false} />
                <Column dataField="InBackorder" caption="In Backorder" visible={false} />
                <Column dataField="OutBackorder" caption="Out Backorder" visible={false} />
                <Column dataField="InUnavailable" caption="In Unavailable" visible={false} />
                <Column dataField="OutUnavailable" caption="Out Unavailable" visible={false} />
                <Column dataField="InFuture" caption="In Future" visible={false} />
                <Column dataField="OutFuture" caption="Out Future" visible={false} />
                <Column dataField="KeySequence" caption="Key Sequence" visible={false} />
                <Column dataField="CreationDateTime" caption="Creation Date" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="CreationUserId" caption="Created By" visible={false} />
                <Column dataField="LastUpdateDateTime" caption="Last Updated" dataType="date" format="MM/dd/yyyy" visible={false} />
                <Column dataField="LastUpdateUserId" caption="Last Updated By" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationInventoryResult);
